import React, { Component } from "react";
import Highlighter from "react-highlight-words";

export class Highlight extends Component {
  render() {
    return (
      <Highlighter
        highlightStyle={{ color: "#178CCC", backgroundColor: "#F0F7FB" }}
        searchWords={[/[@＠][Ａ-Ｚａ-ｚA-Za-z一-鿆0-9０-９ぁ-ヶｦ-ﾟー]+/]}
        autoEscape={false}
        textToHighlight={this.props.textToHighlight}
      />
    );
  }
}

export default Highlight;



// WEBPACK FOOTER //
// ./src/components/Messages/Highlight.js